import React from 'react';
import './Logo.css';

/**
 * Componente Logo NerdzPoker
 * Aceita uma imagem personalizada ou usa o logo padrão
 */

const Logo = ({ size = 'medium', imageSrc }) => {
  // Se uma imagem foi fornecida, usar ela
  if (imageSrc) {
    return (
      <div className={`logo-container logo-${size}`}>
        <img 
          src={imageSrc} 
          alt="NerdzPoker Logo" 
          className="logo-image"
          style={{ maxWidth: size === 'small' ? '120px' : size === 'large' ? '300px' : '200px' }}
        />
      </div>
    );
  }

  // Logo padrão (fallback)
  return (
    <div className={`logo-container logo-${size}`}>
      <div className="logo-shield">
        {/* Glasses */}
        <div className="logo-glasses">👓</div>
        
        {/* NERDZ Text */}
        <div className="logo-text">NERDZ</div>
        
        {/* Card Suits */}
        <div className="logo-suits">
          <span className="suit suit-red suit-1">♠</span>
          <span className="suit suit-white suit-2">♠</span>
          <span className="suit suit-white suit-3">♦</span>
          <span className="suit suit-red suit-4">♦</span>
          <span className="suit suit-white suit-5">♥</span>
          <span className="suit suit-red suit-6">♥</span>
          <span className="suit suit-white suit-7">♣</span>
          <span className="suit suit-red suit-8">♣</span>
        </div>
        
        {/* D20 and Controllers */}
        <div className="logo-gaming">
          <div className="logo-controller left">🎮</div>
          <div className="logo-d20">🎲</div>
          <div className="logo-controller right">🎮</div>
        </div>
        
        {/* POKER TEAM Banner */}
        <div className="logo-banner">POKER TEAM</div>
      </div>
    </div>
  );
};

export default Logo;
